<template>
  <div class="field-group__field grid__col-24 grid__col-lg-16">
    <table>
      <thead>
        <tr>
          <th v-for="(input, index) in inputs" v-bind:key="index">
            {{ input.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, r) in rows" v-bind:key="r">
          <td v-for="(input, i) in inputs" v-bind:key="i">
            <label for="name" class="u-visually-hidden">{{ input.name }}</label>
            <input
              :name="generateInputName(r, input.name)"
              type="text"
              v-model="row[input.name]"
            />
          </td>
          <td>
            <button
              @click.prevent="removeRow(row)"
              type="button"
              class="btn btn--delete"
            >
              <span class="u-visually-hidden">Delete this row</span>
              <span class="icon-cross"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      v-if="values.length < maxRows"
      @click.prevent="addEmptyRow()"
      type="button"
      class="btn btn--add btn--outline btn--left"
    >
      <span class="icon-plus">&nbsp;</span> {{ newRowLabel }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    newRowLabel: { type: String, default: 'Add a new row' },
    maxRows: { type: Number, default: 3 },
    inputs: { type: Array, required: true },
    values: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },

  data() {
    return {
      rows: this.values,
    };
  },

  methods: {
    removeRow(index) {
      this.rows.splice(this.rows.indexOf(index), 1);
    },

    addEmptyRow(index) {
      this.rows.push({});
    },

    generateInputName(index, childInputName) {
      return this.name + '[' + index + '][' + childInputName + ']';
    },
  },
};
</script>
